export default __webpack_public_path__ + "static/6-11c8dd4b8211137e925824f87318688a.png";